/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { Collection } from 'src/app/models/collection';
import {
    AddForceCollectionContentRefresh,
    CollectionAction,
    CreateCollection,
    DeleteCollection,
    ForceCollectionRefresh,
    SetActiveCollection,
    SetCollections,
    UpdateCollection,
} from './collection.actions';

export interface CollectionState {
    collections: Collection[];
    activeCollection: Collection | undefined;
    forceRefresh: boolean;
    forceContentRefreshList: string[];
}

const reducerMap: ActionReducerMap<CollectionState> = {
    activeCollection: activeCollectionReducer,
    collections: collectionsReducer,
    forceContentRefreshList: forceContentRefreshListReducer,
    forceRefresh: forceRefreshReducer,
};

export const selectCollectionState =
    createFeatureSelector<CollectionState>('collection');
export const selectCollections = createSelector(
    selectCollectionState,
    (state) => state.collections
);
export const selectActiveCollection = createSelector(
    selectCollectionState,
    (state) => state.activeCollection
);
export const selectShouldForceCollectionRefresh = createSelector(
    selectCollectionState,
    (state) => state.forceRefresh
);
export const selectShouldForceCollectionContentRefreshList = createSelector(
    selectCollectionState,
    (state) => state.forceContentRefreshList
);

export const collectionStoreModule = StoreModule.forFeature(
    'collection',
    reducerMap
);

function collectionsReducer(state: Collection[] = [], action: Action) {
    switch (action.type) {
        case CollectionAction.createCollection:
            return [...state, (action as CreateCollection).collection];
        case CollectionAction.deleteCollection:
            return state.filter(
                (collection) =>
                    collection.id !== (action as DeleteCollection).collectionId
            );
        case CollectionAction.setCollections:
            return (action as SetCollections).collections;
        case CollectionAction.updateCollection:
            return [
                ...state.filter(
                    (collection) =>
                        collection.id !==
                        (action as UpdateCollection).collection.id
                ),
                (action as UpdateCollection).collection,
            ];
        default:
            return state;
    }
}

function activeCollectionReducer(state: Collection, action: Action) {
    switch (action.type) {
        case CollectionAction.setActiveCollection:
            return (action as SetActiveCollection).collection?.clone();
        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case CollectionAction.forceCollectionRefresh:
            return (action as ForceCollectionRefresh).forceRefresh;
        default:
            return state;
    }
}

function forceContentRefreshListReducer(state: string[] = [], action: Action) {
    switch (action.type) {
        case CollectionAction.addForceCollectionContentRefresh: {
            const contentId = (action as AddForceCollectionContentRefresh)
                .contentId;
            if (!state.includes(contentId)) {
                return [...state, contentId];
            } else {
                return state;
            }
        }
        case CollectionAction.removeForceCollectionContentRefresh: {
            return [];
        }
        default:
            return state;
    }
}
